
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexL6IBblXwOeGe20PFY6CEA_XHd4mNKrrU5AlHwcK4aA4Meta } from "/opt/buildhome/repo/src/pages/index.vue?macro=true";
import { default as indexYZxmz2jGpTs4GdoCCxk2D_XRdGRHtfloV9sENtzbqL8Meta } from "/opt/buildhome/repo/src/pages/search/index.vue?macro=true";
import { default as indexBcisX03r1BRKSulfHg64_45kVSbYrJfU17x5AAbGndw0gMeta } from "/opt/buildhome/repo/src/pages/[handle]/index.vue?macro=true";
import { default as reviewshsma_3t1f84CdgZ_45u1yg33ZjG7QWLyGDQ5HRKH4EtcEMeta } from "/opt/buildhome/repo/src/pages/[handle]/reviews.vue?macro=true";
import { default as editionshQWgyE6TOg2GwTtnApTYQFlGG0VSOopYXZXQIMWffpwMeta } from "/opt/buildhome/repo/src/pages/[handle]/editions.vue?macro=true";
import { default as _91slug_93KSl0zUzxgQLUXPUXYvVIEFAAnDSx5Uly2jwlR5tJ7yMMeta } from "/opt/buildhome/repo/src/pages/categories/[slug].vue?macro=true";
import { default as changelog_45Ssj0q3o3VsHPsBxi1zXEaoOzRj071QxzCFFsbFmKbQMeta } from "/opt/buildhome/repo/src/pages/[handle]/changelog.vue?macro=true";
import { default as indexVASb4O1TgkHr6KUzNKtGKWMSbHceuCXxDavyAubO2B0Meta } from "/opt/buildhome/repo/src/pages/featured/[id]/index.vue?macro=true";
import { default as indexREfDN2YrHGl2cb5UpXxu_45RKNjlDAIx6Yd3OsEseLPC8Meta } from "/opt/buildhome/repo/src/pages/developer/[slug]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexL6IBblXwOeGe20PFY6CEA_XHd4mNKrrU5AlHwcK4aA4Meta || {},
    component: () => import("/opt/buildhome/repo/src/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: indexYZxmz2jGpTs4GdoCCxk2D_XRdGRHtfloV9sENtzbqL8Meta || {},
    component: () => import("/opt/buildhome/repo/src/pages/search/index.vue")
  },
  {
    name: "handle",
    path: "/:handle()",
    meta: indexBcisX03r1BRKSulfHg64_45kVSbYrJfU17x5AAbGndw0gMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/[handle]/index.vue")
  },
  {
    name: "handle-reviews",
    path: "/:handle()/reviews",
    meta: reviewshsma_3t1f84CdgZ_45u1yg33ZjG7QWLyGDQ5HRKH4EtcEMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/[handle]/reviews.vue")
  },
  {
    name: "handle-editions",
    path: "/:handle()/editions",
    meta: editionshQWgyE6TOg2GwTtnApTYQFlGG0VSOopYXZXQIMWffpwMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/[handle]/editions.vue")
  },
  {
    name: "categories-slug",
    path: "/categories/:slug()",
    meta: _91slug_93KSl0zUzxgQLUXPUXYvVIEFAAnDSx5Uly2jwlR5tJ7yMMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/categories/[slug].vue")
  },
  {
    name: "handle-changelog",
    path: "/:handle()/changelog",
    meta: changelog_45Ssj0q3o3VsHPsBxi1zXEaoOzRj071QxzCFFsbFmKbQMeta || {},
    component: () => import("/opt/buildhome/repo/src/pages/[handle]/changelog.vue")
  },
  {
    name: "featured-id",
    path: "/featured/:id()",
    meta: indexVASb4O1TgkHr6KUzNKtGKWMSbHceuCXxDavyAubO2B0Meta || {},
    component: () => import("/opt/buildhome/repo/src/pages/featured/[id]/index.vue")
  },
  {
    name: "developer-slug",
    path: "/developer/:slug()",
    meta: indexREfDN2YrHGl2cb5UpXxu_45RKNjlDAIx6Yd3OsEseLPC8Meta || {},
    component: () => import("/opt/buildhome/repo/src/pages/developer/[slug]/index.vue")
  }
]